import { render, staticRenderFns } from "./commonFolder.vue?vue&type=template&id=164388d0&scoped=true"
import script from "./commonFolder.vue?vue&type=script&lang=js"
export * from "./commonFolder.vue?vue&type=script&lang=js"
import style0 from "./commonFolder.vue?vue&type=style&index=0&id=164388d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164388d0",
  null
  
)

export default component.exports